import { Redirect } from "react-router-dom";
import { FRONTEND_V2_BETA, useFeatureFlag } from "../Contexts/FeatureFlagsContext";
import FullPageLoading from "./FullPageLoading";

/** Where a signed-in user lands: the dashboard for beta users, otherwise the profile. */
export default function LandingRedirect() {
  const { enabled, ready } = useFeatureFlag(FRONTEND_V2_BETA);
  if (!ready) return <FullPageLoading />;
  return <Redirect to={enabled ? "/dashboard" : "/profile"} />;
}
